import type { ParseOptions } from "@tiptap/pm/model";

/**
 * Keeps tabs and consecutive spaces (e.g. from a Word paste) in the document instead of
 * collapsing them, so the editor shows the same spacing as the preview and the coowner view.
 */
export const RICH_TEXT_PARSE_OPTIONS: ParseOptions = { preserveWhitespace: "full" };
